
import * as React from "react"
import { cn } from "@/lib/utils"
import { useSidebar } from "./sidebar-provider"

const Sidebar = ({ className, children, ...props }: React.HTMLAttributes<HTMLElement>) => {
  const { isCollapsed } = useSidebar()
  
  return (
    <aside 
      className={cn(
        "flex flex-col h-screen bg-secondary border-r transition-all duration-300", 
        isCollapsed ? "w-0 overflow-hidden opacity-0" : "w-[250px]",
        className
      )} 
      {...props}
    >
      {children}
    </aside>
  )
}
Sidebar.displayName = "Sidebar"

export { Sidebar }
